/**
 * Gallery Swipe Resize - Mobile Product Preview
 * Mobile only (≤750px) with touch conflict prevention
 * Desktop sticky handled by CSS
 */

document.addEventListener('DOMContentLoaded', function() {
  
  function init() {
    // Only run on mobile (match their breakpoint exactly)
    if (window.innerWidth > 750) return;

    const gallery = document.querySelector('#tee-gallery');
    const galleryContent = document.querySelector('.tee-gallery-content');
    
    // Wait for teeinblue to load
    if (!gallery || !galleryContent) {
      setTimeout(init, 500);
      return;
    }

    console.log('Gallery initialized');

    // Set initial size - start at 92%
    galleryContent.style.width = '100%';
    galleryContent.style.margin = '0 auto';

    // Force re-center after teeinblue renders
    setTimeout(function() {
      galleryContent.style.width = '100%';
      galleryContent.style.margin = '0 auto';
      window.dispatchEvent(new Event('resize'));
    }, 100);

    // Scroll-based resize with top-zone priority
    const maxScroll = 180; // Top zone = first 250px of page
    const minWidth = 58;
    const maxWidth = 100;
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', function() {
      if (window.innerWidth > 750) return;
      
      const scrollY = window.scrollY;
      const scrollingDown = scrollY > lastScrollY;
      lastScrollY = scrollY;

      // TOP ZONE (0-250px): Only auto-animate on downward scroll
      if (scrollY <= maxScroll) {
        if (scrollingDown) {
          // Scrolling down into top zone — remove manual control and animate
          if (galleryContent.classList.contains('resized')) {
            galleryContent.classList.remove('resized');
          }
          const newWidth = maxWidth - (scrollY / maxScroll) * (maxWidth - minWidth);
          galleryContent.style.width = newWidth + '%';
          galleryContent.style.margin = '0 auto';
          window.dispatchEvent(new Event('resize'));
        } else {
          // Scrolling back up into top zone — only animate if not manually controlled
          if (!galleryContent.classList.contains('resized')) {
            const newWidth = maxWidth - (scrollY / maxScroll) * (maxWidth - minWidth);
            galleryContent.style.width = newWidth + '%';
            galleryContent.style.margin = '0 auto';
            window.dispatchEvent(new Event('resize'));
          }
          // If manually resized, leave it alone
        }
      } 
      // BELOW TOP ZONE: Only auto-set if not manually controlled
      else {
        if (!galleryContent.classList.contains('resized')) {
          galleryContent.style.width = minWidth + '%';
          galleryContent.style.margin = '0 auto';
          window.dispatchEvent(new Event('resize'));
        }
      }
    });

    // Create swipe bar
    const bar = document.createElement('div');
    bar.className = 'swipe-bar';
    bar.style.cssText = `
  padding: 8px 0 8px 0 !important;
  height: 18px !important;
  width: 92vw !important;
  margin: 4px auto -15px auto !important;
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  touch-action: pan-y !important;
  -webkit-tap-highlight-color: transparent !important;
  box-shadow: none !important;
  position: relative !important;
  z-index: 11 !important;
`;
    
    const handle = document.createElement('div');
    handle.className = 'swipe-bar-handle';
    handle.style.cssText = `
  width: 110px !important;
  height: 2px !important;
  background: #a5a5a5 !important;
  border-radius: 9px !important;
  cursor: ns-resize !important;
  margin: 0 !important;
  transition: background 0.15s;
`;
    
    bar.appendChild(handle);
    gallery.parentNode.insertBefore(bar, gallery.nextSibling);

    console.log('Swipe bar created');

    // Swipe gesture handling
    let startY = 0;

    bar.addEventListener('touchstart', function(e) {
      startY = e.touches[0].clientY;
      handle.style.background = '#888';
    }, { passive: true });

    bar.addEventListener('touchmove', function(e) {
      // Allow page scroll - do not prevent default
    }, { passive: true });

    bar.addEventListener('touchend', function(e) {
      handle.style.background = '#a5a5a5';
      const endY = e.changedTouches[0].clientY;
      const diff = startY - endY;
      const scrollY = window.scrollY;
      
      // Only allow manual control when BELOW top zone
      if (scrollY > maxScroll) {
        const currentWidth = parseFloat(galleryContent.style.width) || minWidth;

        // Tap (little or no movement) - toggle between min and max
        if (Math.abs(diff) < 5) {
          if (currentWidth <= minWidth + 2) {
            expandImage();
          } else {
            shrinkImage();
          }
        }
        // Swipe up - shrink
        else if (diff > 0) {
          shrinkImage();
        }
        // Swipe down - expand
        else {
          expandImage();
        }
      }
    }, { passive: true });

    // Shrink animation
    function shrinkImage() {
      galleryContent.classList.add('resized'); // Mark as manually controlled
      
      for (let i = 1; i <= 42; i++) {
        setTimeout(function() {
          const newWidth = 100 - i;
          galleryContent.style.width = Math.max(newWidth, 58) + '%';
          galleryContent.style.margin = '0 auto';
          window.dispatchEvent(new Event('resize'));
        }, 5 * i);
      }
    }

    // Expand animation
    function expandImage() {
      galleryContent.classList.add('resized'); // Mark as manually controlled
      
      for (let i = 1; i <= 42; i++) {
        setTimeout(function() {
          const newWidth = 58 + i;
          galleryContent.style.width = Math.min(newWidth, 100) + '%';
          galleryContent.style.margin = '0 auto';
          window.dispatchEvent(new Event('resize'));
        }, 5 * i);
      }
    }
  }

  // Watermark + trust bar - inserted after .product-gallery, fades at scroll 250
  function initWatermark() {
    if (window.innerWidth > 750) return;

    const productGallery = document.querySelector('.product-gallery');
    if (!productGallery) return;

    const container = document.createElement('div');
    container.style.cssText = `
  width: 100vw !important;
  margin-left: calc(-50vw + 50%) !important;
  margin-top: -30px !important;
  background:rgb(255, 255, 255) !important;
  border-radius: 0 0 14px 14px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  padding: 16px 16px 14px 16px !important;
  overflow: hidden !important;
  max-height: 60px !important;
  opacity: 1 !important;
  transition: opacity 0.3s ease, max-height 0.3s ease, padding 0.3s ease !important;
`;

    container.innerHTML = `
      <div style="
        font-size: 15px;
        color: #363636;
        text-align: center;
        font-family: inherit;
        letter-spacing: 0.01em;
        width: 100%;
      ">
        Watermarks are not printed on your final item<br>Scroll Down To Personalise
      </div>
    `;

    productGallery.parentNode.insertBefore(container, productGallery.nextSibling);

    // Fade out when gallery hits smallest size
    window.addEventListener('scroll', function() {
      if (window.innerWidth > 750) return;
      const scrollY = window.scrollY;
      if (scrollY >= 250) {
        container.style.opacity = '0';
      } else {
        container.style.opacity = '1';
        container.style.maxHeight = '160px';
        container.style.padding = '16px 16px 14px 16px';
      }
    });
  }

  // Prevent touch scroll conflicts on image area
  function preventImageScrollConflicts() {
    if (window.innerWidth > 750) return;
    
    const galleryWrapper = document.querySelector('.tee-gallery-wrapper');
    if (!galleryWrapper) return;
    
    let touchStartY = 0;
    
    galleryWrapper.addEventListener('touchstart', function(e) {
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    
    galleryWrapper.addEventListener('touchmove', function(e) {
      const scrollTop = galleryWrapper.scrollTop;
      const scrollHeight = galleryWrapper.scrollHeight;
      const offsetHeight = galleryWrapper.offsetHeight;
      const touchCurrentY = e.touches[0].clientY;
      
      // Prevent rubber-band scroll at boundaries
      const isAtTop = scrollTop === 0;
      const isAtBottom = scrollTop + offsetHeight >= scrollHeight;
      const isScrollingUp = touchCurrentY > touchStartY;
      const isScrollingDown = touchCurrentY < touchStartY;
      
      if ((isAtTop && isScrollingUp) || (isAtBottom && isScrollingDown)) {
        e.preventDefault();
      }
    }, { passive: false });
    
    console.log('Touch conflict prevention enabled');
  }

  // Fix iOS Safari sticky position after inactivity
  function fixStickyTop() {
    if (window.innerWidth > 750) return;
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;
    if (window.visualViewport) {
      gallery.style.top = window.visualViewport.offsetTop + 'px';
    }
  }

  function initStickyFix() {
    if (window.innerWidth > 750) return;
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', fixStickyTop);
      window.visualViewport.addEventListener('scroll', fixStickyTop);
    }
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'visible') {
        setTimeout(fixStickyTop, 100);
        setTimeout(fixStickyTop, 500);
      }
    });
    window.addEventListener('pageshow', function(event) {
  setTimeout(fixStickyTop, 100);
  setTimeout(fixStickyTop, 500);
  if (event.persisted) {
    // Page restored from bfcache - reinitialise gallery state
    const galleryContent = document.querySelector('.tee-gallery-content');
    if (galleryContent) {
      galleryContent.classList.remove('resized');
      galleryContent.style.width = '100%';
      galleryContent.style.margin = '0 auto';
      window.dispatchEvent(new Event('resize'));
    }
  }
});
  }

  // Initialize all functions
  init();
  initWatermark();
  preventImageScrollConflicts();
  initStickyFix();
});